import {cssTheme} from '@logistics-frontend/blocks'
import {css} from '@logistics-frontend/blocks/theme/css'
import {breakpoints, spacing} from '@logistics-frontend/blocks/theme/theme'

export const classes = {
  modal: css`
    max-inline-size: ${spacing(96)}; // 768px

    ${breakpoints.down('sm')} {
      position: absolute;
      inset: 0;
      border-radius: 0;
    }
  `,
  titleWrap: css`
    margin-block-end: ${spacing(-3)};
    padding: ${spacing(3)};

    ${breakpoints.down('sm')} {
      margin-block-end: ${spacing(-2)};
      padding: ${spacing(3, 2)};
    }
  `,
  subTitle: css`
    margin-block-start: ${spacing(1.5)} !important;
  `,
  footer: css`
    background-color: ${cssTheme.default.day.background};
    inset-block-end: 0;
    inset-inline-start: 0;
    margin-block-start: ${spacing(-3)};
    padding: ${spacing(2)};
    position: sticky;

    ${breakpoints.down('sm')} {
      inline-size: 100%;
      padding: ${spacing(1)};
      position: fixed;
    }
  `,
}
